import { lang } from '@lang/interfaces/lang';

export default function getFlag(lang: lang) {
    switch (lang) {
        case 'ru':
            return 'public/img/svg/ru.svg';
        case 'en':
            return 'public/img/svg/gb.svg';
        default:
            return '';
    }
}
